import {useState, useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {notificationAPI} from "../../../api/api"
import {format} from 'date-fns';
import styles from "./NotificationPage.module.css"

export const NotificationPage = () => {

    const {id} = useParams();
    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(true);
    const [pageModel, setPageModel] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchDataInfo();
    }, [])


    const fetchDataInfo = async() => {
        try{
            const {data} = await notificationAPI.getNotificationById(id);
            const resp = JSON.parse(data);
            if(resp.isSucccess){
                console.log('notificationPageModel', resp)
                setPageModel(resp.data)
            }
            else{
                setErrorMessage(resp.message)
            }
        
        }
        catch(e){

        }
        setIsLoading(false)
    }

    if (isLoading === true) {
        return <div className={styles.pageWrapper} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <h4>Завантажуємо...</h4>
                </div>; 
    }
    
    if(errorMessage){
        return <div className={styles.pageWrapper} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <h4>{errorMessage}</h4>
                </div>; 
    }

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.notificationContainer}>
                <div className={styles.notificationHeader}>
                    <h1 className={styles.notificationSubject}>{pageModel.Subject}</h1>
                    <span className={styles.notificationDate}>
                        {format(new Date(pageModel.CreateOn), 'dd.MM.yyyy HH:mm:ss')}
                    </span>
                </div>
                <div
                    className={styles.notificationContent}
                    dangerouslySetInnerHTML={{__html: pageModel.MessageContent}}
                />
                <div className={styles.notificationFooter}>
                    <button onClick={() => navigate(-1)} className={styles.backButton}>Назад</button>
                </div>
            </div>
        </div>
    )
}